import { createStore } from "zustand";
import { type TimeRange } from "./ChartSpec";
import { createHoverTimeSlice, type HoverTimeSlice } from "./crosshair/hover-time-slice";
import { createLeftAxisSlice, type LeftAxisSlice } from "./panels/left-axis-slice";
import { createDebugForceRawSlice, type DebugForceRawSlice } from "./resolution/debug-force-raw-slice";
import { createPanelResolutionSlice, type PanelResolutionSlice } from "./resolution/panel-resolution-slice";
import { createTimeRangeSlice, type TimeRangeSlice } from "./time-window/time-range-slice";
import { createUnitOverridesSlice, type UnitOverridesSlice } from "./units/unit-overrides-slice";

export type DataViewerState = TimeRangeSlice &
    HoverTimeSlice &
    PanelResolutionSlice &
    UnitOverridesSlice &
    LeftAxisSlice &
    DebugForceRawSlice;

export const createDataViewerStore = (defaultTimeRange?: TimeRange) =>
    createStore<DataViewerState>()((...a) => ({
        ...createTimeRangeSlice(defaultTimeRange)(...a),
        ...createHoverTimeSlice(...a),
        ...createPanelResolutionSlice(...a),
        ...createUnitOverridesSlice(...a),
        ...createLeftAxisSlice(...a),
        ...createDebugForceRawSlice(...a),
    }));
